/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { GetApiUserManagementV1NotificationsParams, ProblemDetails } from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1Notifications = (
  params?: GetApiUserManagementV1NotificationsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/notifications`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1NotificationsQueryKey = (params?: GetApiUserManagementV1NotificationsParams) => {
  return [`/api/user-management/v1/notifications`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1NotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1NotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1NotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>> = ({ signal }) =>
    getApiUserManagementV1Notifications(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1NotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>>;
export type GetApiUserManagementV1NotificationsQueryError = unknown;

export function useGetApiUserManagementV1Notifications<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
  TError = unknown
>(
  params: undefined | GetApiUserManagementV1NotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Notifications<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1NotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Notifications<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1NotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1Notifications<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1NotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Notifications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1NotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1NotificationsIdRead = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/notifications/${id}/read`, method: 'POST', signal }, options);
};

export const getPostApiUserManagementV1NotificationsIdReadMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext> => {
  const mutationKey = ['postApiUserManagementV1NotificationsIdRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return postApiUserManagementV1NotificationsIdRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1NotificationsIdReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>
>;

export type PostApiUserManagementV1NotificationsIdReadMutationError = ProblemDetails;

export const usePostApiUserManagementV1NotificationsIdRead = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext> => {
  return useMutation(getPostApiUserManagementV1NotificationsIdReadMutationOptions(options), queryClient);
};
export const patchApiUserManagementV1NotificationsIdRead = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/notifications/${id}/read`, method: 'PATCH', signal }, options);
};

export const getPatchApiUserManagementV1NotificationsIdReadMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext> => {
  const mutationKey = ['patchApiUserManagementV1NotificationsIdRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return patchApiUserManagementV1NotificationsIdRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiUserManagementV1NotificationsIdReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>
>;

export type PatchApiUserManagementV1NotificationsIdReadMutationError = ProblemDetails;

export const usePatchApiUserManagementV1NotificationsIdRead = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof patchApiUserManagementV1NotificationsIdRead>>, TError, { id: number }, TContext> => {
  return useMutation(getPatchApiUserManagementV1NotificationsIdReadMutationOptions(options), queryClient);
};
export const postApiUserManagementV1NotificationsIdDismiss = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/notifications/${id}/dismiss`, method: 'POST', signal }, options);
};

export const getPostApiUserManagementV1NotificationsIdDismissMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>, TError, { id: number }, TContext> => {
  const mutationKey = ['postApiUserManagementV1NotificationsIdDismiss'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return postApiUserManagementV1NotificationsIdDismiss(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1NotificationsIdDismissMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>
>;

export type PostApiUserManagementV1NotificationsIdDismissMutationError = ProblemDetails;

export const usePostApiUserManagementV1NotificationsIdDismiss = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsIdDismiss>>, TError, { id: number }, TContext> => {
  return useMutation(getPostApiUserManagementV1NotificationsIdDismissMutationOptions(options), queryClient);
};
export const postApiUserManagementV1NotificationsClearAll = (options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/notifications/clear-all`, method: 'POST', signal }, options);
};

export const getPostApiUserManagementV1NotificationsClearAllMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>, TError, void, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>, TError, void, TContext> => {
  const mutationKey = ['postApiUserManagementV1NotificationsClearAll'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>, void> = () => {
    return postApiUserManagementV1NotificationsClearAll(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1NotificationsClearAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>
>;

export type PostApiUserManagementV1NotificationsClearAllMutationError = unknown;

export const usePostApiUserManagementV1NotificationsClearAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>, TError, void, TContext>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1NotificationsClearAll>>, TError, void, TContext> => {
  return useMutation(getPostApiUserManagementV1NotificationsClearAllMutationOptions(options), queryClient);
};
